import {lazyRegister} from "@/Core/lazyRegister";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {AccountInfoByLoginIdResult, UserToken} from "@/models";

export class AuthService {
    static $inject = ['BaseApiFactory'];
    session: {
        data: AccountInfoByLoginIdResult;
        account: string;
    };

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    /**
     * Xác thực thông qua bên thứ ba (External Provider)
     */
    public verifyExternal(postData: {
        provider: string,
        origin: string,
        code: string
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<UserToken>(
            `/v2/api/auth/create-token-by-${postData.provider}`,
            postData, cancelToken
        );
    }

    /**
     * Xác thực bằng mật khẩu truyền thống
     */
    public verifyPassword(postData: any, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<UserToken>(
            '/v2/api/auth/create-token-by-password',
            postData, cancelToken
        );
    }

    public verifyOtp(accessToken: string, {code, type}: {
        code: string;
        type: string
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<UserToken>(
            `/v2/api/auth/create-token-by-otp/${type}`,
            {
                code
            },
            cancelToken, {
                accessToken
            }
        );
    }

    public getAccountInfoByLoginId(userName: string, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<AccountInfoByLoginIdResult>(
            '/v2/api/auth/name',
            {userName},
            cancelToken
        );
    }
}

lazyRegister.service('AuthService', AuthService);
